export const NOT_INVITED = 'notInvited';
export const INVITED ='invited';
export const AUTHORIZED = 'authorized';

export const administeredSessionRespondentStatuses = {
  0: NOT_INVITED,
  1: INVITED,
  2: AUTHORIZED
};